<script lang="ts">
	import { getGlobalSettings } from "../../contexts/getGlobalSettings.js";

	const { COOKIES, GOOGLE_ANALYTICS } = getGlobalSettings();

	/* eslint-disable */
</script>

<svelte:head>
	<link rel="preconnect" href="https://cdn.cookie-script.com" />

	{@html `
	<script>
		window.dataLayer = window.dataLayer || [];
		function gtag(){window.dataLayer.push(arguments);}

		gtag('consent', 'default', {
			'ad_storage': 'denied',
			'ad_user_data': 'denied',
			'ad_personalization': 'denied',
			'analytics_storage': 'denied',
			'functionality_storage': 'denied',
			'personalization_storage': 'denied',
			'security_storage': 'granted',
			'wait_for_update': 500
		});
	</script>
	`}

	{@html `<script type="text/javascript" charset="UTF-8" src="https://cdn.cookie-script.com/s/${COOKIES}.js" async></script>`}

	{@html `<script async src="https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS}"></script>`}
	{@html `
	<script>
		gtag('js', new Date());
		gtag('config', '${GOOGLE_ANALYTICS}');
	</script>
	`}
</svelte:head>
